var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.revokeDiaVisible, title: "撤销原因", width: "50%" },
      on: {
        "update:visible": function ($event) {
          _vm.revokeDiaVisible = $event
        },
        close: function ($event) {
          return _vm.dialogCancle()
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "dialogBox" },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "form",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "180px",
              },
            },
            [
              _c(
                "el-row",
                [
                  !_vm.isEdit
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "撤销时间：", size: "small" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.ruleForm.revokeTime)),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "撤销原因：",
                            prop: "reason",
                            size: "small",
                          },
                        },
                        [
                          _vm.isEdit
                            ? _c("el-input", {
                                attrs: {
                                  rows: 3,
                                  clearable: "",
                                  maxlength: "1000",
                                  placeholder: "请输入",
                                  "show-word-limit": "",
                                  type: "textarea",
                                },
                                model: {
                                  value: _vm.ruleForm.reason,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "reason", $$v)
                                  },
                                  expression: "ruleForm.reason",
                                },
                              })
                            : _c("span", [_vm._v(_vm._s(_vm.ruleForm.reason))]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "撤销执行人：",
                            prop: "displayName",
                            size: "small",
                          },
                        },
                        [
                          _vm.isEdit
                            ? _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  disabled: "",
                                  maxlength: "50",
                                  placeholder: "请输入",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.ruleForm.displayName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "displayName", $$v)
                                  },
                                  expression: "ruleForm.displayName",
                                },
                              })
                            : _c("span", [
                                _vm._v(_vm._s(_vm.ruleForm.displayName)),
                              ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "执行部门：",
                            prop: "owerDeptName",
                            size: "small",
                          },
                        },
                        [
                          _vm.isEdit
                            ? _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  disabled: "",
                                  maxlength: "50",
                                  placeholder: "请输入",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.ruleForm.owerDeptName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "owerDeptName", $$v)
                                  },
                                  expression: "ruleForm.owerDeptName",
                                },
                              })
                            : _c("span", [
                                _vm._v(_vm._s(_vm.ruleForm.owerDeptName)),
                              ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "处理文件文号：",
                            prop: "fileName",
                            size: "small",
                          },
                        },
                        [
                          _vm.isEdit
                            ? _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  disabled: "",
                                  maxlength: "50",
                                  placeholder: "请输入",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.ruleForm.fileName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "fileName", $$v)
                                  },
                                  expression: "ruleForm.fileName",
                                },
                              })
                            : _c("span", [
                                _vm._v(_vm._s(_vm.ruleForm.fileName)),
                              ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "公开范围：",
                            prop: "scopeType",
                            size: "small",
                          },
                        },
                        _vm._l(_vm.publicScopeList, function (item, index) {
                          return _c(
                            "el-radio",
                            {
                              key: index,
                              attrs: { label: item.value, disabled: "" },
                              model: {
                                value: _vm.ruleForm.scopeType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "scopeType", $$v)
                                },
                                expression: "ruleForm.scopeType",
                              },
                            },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                _vm._l(_vm.ruleForm.attachments, function (item, index) {
                  return _c(
                    "el-col",
                    { key: index, attrs: { span: 24 } },
                    [
                      _vm.isEdit
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: item.fileTypeName
                                  ? item.fileTypeName + "："
                                  : "附件：",
                                prop: "attachments" + item.fileType,
                                size: "small",
                              },
                            },
                            [
                              _c("affix-msg", {
                                attrs: { docItem: item, docName: item.name },
                                on: {
                                  "update:docItem": function ($event) {
                                    item = $event
                                  },
                                  "update:doc-item": function ($event) {
                                    item = $event
                                  },
                                  "update:docName": function ($event) {
                                    return _vm.$set(item, "name", $event)
                                  },
                                  "update:doc-name": function ($event) {
                                    return _vm.$set(item, "name", $event)
                                  },
                                  uploadSuccess: _vm.uploadSuccess,
                                },
                              }),
                            ],
                            1
                          )
                        : _c("affix-doc", {
                            staticClass: "affixDown",
                            attrs: { item: item, name: item.fileTypeName },
                            on: {
                              "update:item": function ($event) {
                                item = $event
                              },
                            },
                          }),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.isEdit
        ? _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.dialogCancle()
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveDetail()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.dialogCancle()
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }